import { render } from "./SetMenu.vue?vue&type=template&id=4ee21acf&scoped=true"
import script from "./SetMenu.vue?vue&type=script&lang=js"
export * from "./SetMenu.vue?vue&type=script&lang=js"

import "./SetMenu.vue?vue&type=style&index=0&id=4ee21acf&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ee21acf"]])

export default __exports__